import { useTranslation } from 'utils/use-translation'

import cn from 'classnames'

import DiscountCheckpoint from '../discount-checkpoint'

import { DiscountInfoProps, DiscountLevel } from '../../loyalty-program.props'

import { discountData } from '../../data'

import styles from './styles.module.scss'

const DiscountInfoMobile = ({ isKycVerified, discountLevel }: DiscountInfoProps) => {
  const { firstCheckpoint, secondCheckpoint } = discountData
  const { t, replacePlaceholdersWithElements } = useTranslation()

  const isCheckpointChecked = {
    0: discountLevel !== DiscountLevel.FIRST,
    1: discountLevel === DiscountLevel.THIRD,
  }

  return (
    <ul className={styles.discount__list}>
      {[0, 1].map((_, index) => {
        const loansValue = index === 0 ? '500k' : '1kk'

        const replacedPlaceholdersElements = {
          percent_from: <span>{index === 0 ? firstCheckpoint.percent : secondCheckpoint.percent}%</span>,
          percent_to: <span>{index === 0 ? firstCheckpoint.kycPercent : secondCheckpoint.kycPercent}%</span>,
          value: loansValue,
        }
        const replacedPlaceholdersElementsKyc = {
          percent_from: <span>{index === 0 ? firstCheckpoint.kycPercent : secondCheckpoint.kycPercent}%</span>,
          value: loansValue,
        }

        return (
          <li key={index} className={cn(styles.discount__item, { [styles.checked]: isCheckpointChecked[index] })}>
            <DiscountCheckpoint
              className={styles['discount__item-checkpoint']}
              isChecked={isCheckpointChecked[index]}
            />
            <p className={styles['discount__item-title']}>
              {replacePlaceholdersWithElements(
                t(isKycVerified ? 'discount_checkpoint_with_kyc' : 'discount_checkpoint'),
                isKycVerified ? replacedPlaceholdersElementsKyc : replacedPlaceholdersElements,
              )}
            </p>
          </li>
        )
      })}
    </ul>
  )
}

export default DiscountInfoMobile
